// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"select_dropdown__1YI2T","dropdown_btn":"select_dropdown_btn__gF_1G","dropdown_content":"select_dropdown_content__i6ygR","dropdown_item":"select_dropdown_item__AU9zG"};